<template>
  <p class="whitespace-no-wrap" ref="textSpan"><slot></slot>{{ text }}</p>
</template>

<script>
export default {
  props: {
    longText: String,
    shortText: String,
    toleranceInPx: Number,
    refresh: Boolean
  },
  data() {
    return {
      text: this.longText,
      isShort: true
    }
  },
  watch: {
    selectedLabelsCount() {
      this.handleResize()
    },
    refresh() {
      if (this.refresh === true) {
        this.handleResize()
      }
    }
  },
  methods: {
    handleResize() {
      this.text = this.longText
      this.isShort = false
      this.$nextTick(() => {
        this.setText()
      })
    },
    setText() {
      if (this.getTextWidth() >= this.getParentWidth()) {
        this.text = this.shortText
        this.isShort = true
      } else {
        this.text = this.longText
        this.isShort = false
      }
    },
    getParentWidth() {
      return this.$refs.textSpan.parentElement.offsetWidth - this.toleranceInPx
    },
    getTextWidth() {
      return this.$refs.textSpan.offsetWidth
    }
  },
  mounted() {
    this.setText()
  }
}
</script>

<style></style>
